export default "__VITE_ASSET__5c1ef56c__"